module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Grievances-Addressing/grievaces-addressing-grid/grievaces-addressing-grid.component.css
// module id = ./src/app/Grievances-Addressing/grievaces-addressing-grid/grievaces-addressing-grid.component.css
// module chunks = main